import EmptyMessage from '../common/EmptyMessage.jsx';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ProductCard from './ProductCard.jsx';
import React from 'react';
import {QUOTA_MANAGER_MODES} from '@app/constants/quotaManager';
import {array, bool, func, object, string} from 'prop-types';

const InProgressTabContent = ({
  product,
  features,
  loading,
  selectedFeatureRefs,
  setSelectedFeatureRefs,
  setZoomedFeature,
  onReserve,
  mode,
  collectionId,
}) => {
  if (!product) {
    return (
      <EmptyMessage
        height="100%"
        icon={<Inventory2OutlinedIcon />}
        title="No products selected"
        description={`Please select a data product to ${mode === QUOTA_MANAGER_MODES.PREVIEW ? 'preview quota costs' : 'start quota reservation'}`}
      />
    );
  }

  return (
    <ProductCard
      product={product}
      features={features}
      loading={loading}
      onZoomToFeature={feature => {
        setZoomedFeature(feature);
      }}
      selectedFeatureRefs={selectedFeatureRefs}
      setSelectedFeatureRefs={setSelectedFeatureRefs}
      mode={mode}
      onReserve={onReserve}
      collectionId={collectionId}
    />
  );
};

InProgressTabContent.propTypes = {
  product: object,
  features: array,
  loading: bool,
  selectedFeatureRefs: array,
  setSelectedFeatureRefs: func,
  setZoomedFeature: func,
  onReserve: func,
  mode: string,
  collectionId: string,
};

export default InProgressTabContent;
